import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter2({ data }) {
  const { eyebrow, head, copy, footnote, hyperlink } = data;
  return (
    <div className="chapters__chapter">
      <div className="chapters__chapter__panelist">
        <div className="chapters__chapter__panelist__dash chapters__chapter__panelist__dash--blue" />
        {eyebrow}
      </div>
      <h3 className="blue">{head}</h3>
      <p>{copy[0]}</p>
      <p>{copy[1]}</p>
      <p>
        {copy[2]}
        <Hyperlink hyperlinkData={hyperlink} />
        {copy[3]}
        <sup className="chapters__footnote__num blue">1</sup>
      </p>
      <p>{copy[4]}</p>
      <p>{copy[5]}</p>

      <div className="chapters__footnote">
        <div className="chapters__footnote__item">
          <sup className="chapters__footnote__num blue">1</sup>
          <span className="chapters__footnote__text">
            {footnote.title} <br />{' '}
            <span className="chapters__footnote__text--it">{footnote.src}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Chapter2;
